import React, { useEffect, useState } from 'react';
import {
    FaChevronDown,
    FaChevronUp,
    FaMapMarkerAlt,
    FaPlaneArrival,
    FaPlaneDeparture,
    FaPlus,
    FaSave,
    FaTrash,
} from 'react-icons/fa';
import { toast } from 'react-toastify';
import ErpTemplate from '../../components/ErpTemplate';
import api from '../../services/api';
import { useHistory } from 'react-router-dom';

const ORIGIN_EMPTY_KEY = '__sem_origem__';
const BRAND_NAVY = '#1f3c88';
const BRAND_BLUE = '#2d7ff9';
const BRAND_SKY = '#eef6ff';
const BRAND_BORDER = '#dbe8f8';

const IDA_FIELDS = [
    { key: 'idadata', label: 'Data Ida' },
    { key: 'idacompanhia', label: 'Companhia Ida' },
    { key: 'idavoo', label: 'Voo Ida' },
    { key: 'idaorigem', label: 'Origem Ida' },
    { key: 'idadestino', label: 'Destino Ida' },
    { key: 'idahorasaida', label: 'Hora Saída Ida' },
    { key: 'idahorachegada', label: 'Hora Chegada Ida' },
];

const RETORNO_FIELDS = [
    { key: 'retornodata', label: 'Data Retorno' },
    { key: 'retornocompanhia', label: 'Companhia Retorno' },
    { key: 'retornovoo', label: 'Voo Retorno' },
    { key: 'retornoorigem', label: 'Origem Retorno' },
    { key: 'retornodestino', label: 'Destino Retorno' },
    { key: 'retornohorasaida', label: 'Hora Saída Retorno' },
    { key: 'retornohorachegada', label: 'Hora Chegada Retorno' },
];

function createEmptyOption(origin = '') {
    return {
        aeroportoOrigem: origin,
        idadata: '',
        idacompanhia: '',
        idavoo: '',
        idaorigem: '',
        idadestino: '',
        idahorasaida: '',
        idahorachegada: '',
        retornodata: '',
        retornocompanhia: '',
        retornovoo: '',
        retornoorigem: '',
        retornodestino: '',
        retornohorasaida: '',
        retornohorachegada: '',
    };
}

function getOriginKey(origin) {
    const originLabel = (origin ?? '').trim();
    return originLabel !== '' ? originLabel : ORIGIN_EMPTY_KEY;
}

function getOriginLabel(origin) {
    const originLabel = (origin ?? '').trim();
    return originLabel !== '' ? originLabel : 'Sem origem definida';
}

function optionHasAnyValue(option) {
    return Object.entries(option ?? {}).some(([key, value]) => key !== 'id' && (value ?? '').toString().trim() !== '');
}

function buildOriginGroups(options) {
    const groups = [];
    const groupIndexByKey = {};

    (options ?? []).forEach((option, rowIndex) => {
        const originValue = option?.aeroportoOrigem ?? '';
        const originKey = getOriginKey(originValue);

        if (groupIndexByKey[originKey] === undefined) {
            groupIndexByKey[originKey] = groups.length;
            groups.push({
                key: originKey,
                originValue,
                label: getOriginLabel(originValue),
                items: [],
            });
        }

        groups[groupIndexByKey[originKey]].items.push({
            rowIndex,
            option,
        });
    });

    return groups;
}

function createExpandedState(options) {
    const expanded = {};

    buildOriginGroups(options).forEach((group) => {
        expanded[group.key] = true;
    });

    if (Object.keys(expanded).length === 0) {
        expanded[ORIGIN_EMPTY_KEY] = true;
    }

    return expanded;
}

function renderFieldGrid(fields, option, onChange) {
    return (
        <div className="row">
            {fields.map((field) => (
                <div className="col-sm-6 col-lg-3" key={field.key}>
                    <div className="form-group mb-3">
                        <label
                            style={{
                                color: BRAND_NAVY,
                                display: 'block',
                                fontSize: 12,
                                fontWeight: 700,
                                letterSpacing: '0.04em',
                                marginBottom: 6,
                                textTransform: 'uppercase',
                            }}
                        >
                            {field.label}
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            style={{
                                background: '#fff',
                                border: `1px solid ${BRAND_BORDER}`,
                                borderRadius: 12,
                                boxShadow: 'none',
                                minHeight: 44,
                            }}
                            value={option?.[field.key] ?? ''}
                            onChange={(event) => onChange(field.key, event.target.value)}
                        />
                    </div>
                </div>
            ))}
        </div>
    );
}

function SoftActionButton({ icon, label, onClick, color = 'primary', type = 'button' }) {
    const palette = color === 'warning'
        ? { background: '#fff4e8', border: '#ffd7a8', color: '#c96a00' }
        : { background: '#ffffff', border: 'rgba(255,255,255,0.28)', color: BRAND_NAVY };

    return (
        <button
            type={type}
            onClick={onClick}
            className="btn"
            style={{
                alignItems: 'center',
                background: palette.background,
                border: `1px solid ${palette.border}`,
                borderRadius: 999,
                color: palette.color,
                display: 'inline-flex',
                fontWeight: 600,
                gap: 8,
                padding: '8px 14px',
            }}
        >
            {icon}
            <span>{label}</span>
        </button>
    );
}

export default function CadastroEventoRsvpOpcaoAereo({ match }) {
    const id = match.params.id;
    const empresa = localStorage.getItem('empresa');
    const token = localStorage.getItem('token');
    const [dados, setDados] = useState({ opcoes: [] });
    const [expandedOrigins, setExpandedOrigins] = useState({});
    const history = useHistory();
    const params = new URLSearchParams(window.location.search);
    const idParticipante = params.get('idParticipante');

    const buscar = () => {
        if (!id) {
            setDados({ opcoes: [] });
            setExpandedOrigins(createExpandedState([]));
            return;
        }

        api({
            method: 'get',
            action: '/eventoAereo',
            params: {
                evento: id,
                idParticipante,
            },
            token,
        }).then((response) => {
            const dadosRecebidos = response.data.data;
            const opcoes = dadosRecebidos.opcoes ?? [];

            setDados({
                ...dadosRecebidos,
                opcoes,
            });
            setExpandedOrigins(createExpandedState(opcoes));
        }).catch(() => {
            toast.error('Erro ao carregar opções aéreas');
        });
    };

    const updateOptions = (nextOptions) => {
        setDados((current) => ({
            ...current,
            opcoes: nextOptions,
        }));
    };

    const updateOptionField = (rowIndex, field, value) => {
        const nextOptions = [...(dados.opcoes ?? [])];
        nextOptions[rowIndex] = {
            ...createEmptyOption(),
            ...(nextOptions[rowIndex] ?? {}),
            [field]: value,
        };
        updateOptions(nextOptions);
    };

    const updateOriginForGroup = (group, value) => {
        const nextOptions = [...(dados.opcoes ?? [])];

        group.items.forEach(({ rowIndex }) => {
            nextOptions[rowIndex] = {
                ...createEmptyOption(),
                ...(nextOptions[rowIndex] ?? {}),
                aeroportoOrigem: value,
            };
        });

        updateOptions(nextOptions);
        setExpandedOrigins((current) => ({
            ...current,
            [getOriginKey(value)]: true,
        }));
    };

    const removeOption = (rowIndex) => {
        const nextOptions = [...(dados.opcoes ?? [])];
        nextOptions.splice(rowIndex, 1);
        updateOptions(nextOptions);
    };

    const addOptionToOrigin = (originValue) => {
        updateOptions([
            ...(dados.opcoes ?? []),
            createEmptyOption(originValue),
        ]);
        setExpandedOrigins((current) => ({
            ...current,
            [getOriginKey(originValue)]: true,
        }));
    };

    const addNewOrigin = () => {
        updateOptions([
            ...(dados.opcoes ?? []),
            createEmptyOption(''),
        ]);
        setExpandedOrigins((current) => ({
            ...current,
            [ORIGIN_EMPTY_KEY]: true,
        }));
    };

    const toggleOrigin = (originKey) => {
        setExpandedOrigins((current) => ({
            ...current,
            [originKey]: !current[originKey],
        }));
    };

    const salvar = () => {
        const opcoes = (dados.opcoes ?? []).filter(optionHasAnyValue);

        api({
            method: 'put',
            action: '/eventoAereo/' + id,
            token,
            data: {
                participante: idParticipante,
                evento: id,
                empresa,
                opcoes,
            },
        }).then(() => {
            toast.success('Opções aéreas salvas');

            if (idParticipante) {
                history.push('/cadastroEventoParticipante/' + idParticipante);
                return;
            }

            history.push('/cadastroEventoRsvp/' + id);
        }).catch((error) => {
            toast.error('Erro: ' + (error.response?.data?.error ?? 'ao salvar opções aéreas'));
        });
    };

    useEffect(() => {
        buscar();
        // eslint-disable-next-line
    }, []);

    const gruposOrigem = buildOriginGroups(dados.opcoes);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid">
                <div className="page-title mb-3">
                    <div
                        style={{
                            background: 'linear-gradient(135deg, #f7fbff 0%, #edf4ff 100%)',
                            border: `1px solid ${BRAND_BORDER}`,
                            borderRadius: 22,
                            boxShadow: '0 18px 40px rgba(31, 60, 136, 0.08)',
                            padding: 24,
                        }}
                    >
                        <div className="row align-items-center">
                            <div className="col-lg-8">
                                <div
                                    style={{
                                        color: BRAND_BLUE,
                                        fontSize: 12,
                                        fontWeight: 800,
                                        letterSpacing: '0.12em',
                                        marginBottom: 10,
                                        textTransform: 'uppercase',
                                    }}
                                >
                                    Opções de Aéreo
                                </div>
                                <h3 style={{ color: BRAND_NAVY, fontSize: 36, fontWeight: 700, marginBottom: 8 }}>
                                    {dados.evento?.nomersvp ?? dados.evento?.nome ?? 'Opções de Aéreo'}
                                </h3>
                                <div style={{ color: '#5f6f8a', fontSize: 16, maxWidth: 720 }}>
                                    Gerencie manualmente as opções por origem, ajuste um voo específico sem precisar reimportar a planilha e mantenha o evento organizado.
                                </div>
                            </div>
                            <div className="col-lg-4 mt-3 mt-lg-0">
                                <div
                                    style={{
                                        background: '#ffffff',
                                        border: `1px solid ${BRAND_BORDER}`,
                                        borderRadius: 18,
                                        padding: 18,
                                    }}
                                >
                                    <div style={{ color: '#7b8ba7', fontSize: 12, fontWeight: 700, letterSpacing: '0.08em', marginBottom: 6, textTransform: 'uppercase' }}>
                                        Resumo
                                    </div>
                                    <div style={{ color: BRAND_NAVY, fontSize: 16, fontWeight: 700 }}>
                                        {gruposOrigem.length} {gruposOrigem.length !== 1 ? 'origens' : 'origem'}
                                    </div>
                                    <div style={{ color: '#5f6f8a', marginTop: 4 }}>
                                        {(dados.opcoes ?? []).filter(optionHasAnyValue).length} {((dados.opcoes ?? []).filter(optionHasAnyValue).length !== 1) ? 'opções cadastradas' : 'opção cadastrada'}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-sm-12">
                            <div className="card border-0" style={{ background: 'transparent', boxShadow: 'none' }}>
                                <div className="card-content">
                                    <div className="card-body px-0">
                                        {dados.participante?.id ? (
                                            <div
                                                className="mb-3"
                                                style={{
                                                    background: '#fff',
                                                    border: `1px solid ${BRAND_BORDER}`,
                                                    borderRadius: 18,
                                                    padding: 18,
                                                }}
                                            >
                                                <div style={{ color: '#7b8ba7', fontSize: 12, fontWeight: 700, letterSpacing: '0.08em', marginBottom: 6, textTransform: 'uppercase' }}>
                                                    Participante
                                                </div>
                                                <div style={{ color: BRAND_NAVY, fontSize: 18, fontWeight: 700 }}>
                                                    {dados.participante?.nome ?? ''}
                                                </div>
                                            </div>
                                        ) : null}

                                        <div
                                            className="mb-3"
                                            style={{
                                                alignItems: 'center',
                                                background: 'linear-gradient(135deg, #1f3c88 0%, #2d7ff9 100%)',
                                                borderRadius: 18,
                                                boxShadow: '0 16px 32px rgba(45, 127, 249, 0.22)',
                                                color: '#fff',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                padding: 20,
                                            }}
                                        >
                                            <div>
                                                <div style={{ fontSize: 20, fontWeight: 700, marginBottom: 4 }}>
                                                    Origens e opções organizadas
                                                </div>
                                                <div style={{ opacity: 0.88 }}>
                                                    Edite datas, companhias e voos por origem. Cada bloco agrupa as alternativas daquela cidade.
                                                </div>
                                            </div>
                                            <div className="mt-3 mt-lg-0">
                                                <button
                                                    type="button"
                                                    onClick={addNewOrigin}
                                                    className="btn"
                                                    style={{
                                                        background: '#fff',
                                                        borderRadius: 999,
                                                        color: BRAND_NAVY,
                                                        fontWeight: 700,
                                                        padding: '10px 18px',
                                                    }}
                                                >
                                                    <FaPlus size={14} style={{ marginRight: 8 }} />
                                                    Adicionar nova origem
                                                </button>
                                            </div>
                                        </div>

                                        <form className="form" onSubmit={(event) => { salvar(); event.preventDefault(); }}>
                                            {gruposOrigem.length === 0 ? (
                                                <div
                                                    style={{
                                                        background: '#fff',
                                                        border: `1px dashed ${BRAND_BORDER}`,
                                                        borderRadius: 20,
                                                        color: '#7b8ba7',
                                                        padding: '48px 24px',
                                                        textAlign: 'center',
                                                    }}
                                                >
                                                    Nenhuma opção cadastrada. Adicione uma origem ou importe um arquivo XLS.
                                                </div>
                                            ) : null}

                                            {gruposOrigem.map((group) => {
                                                const isExpanded = expandedOrigins[group.key] ?? true;

                                                return (
                                                    <div
                                                        className="mb-4"
                                                        key={group.key}
                                                        style={{
                                                            background: '#fff',
                                                            border: `1px solid ${BRAND_BORDER}`,
                                                            borderRadius: 22,
                                                            boxShadow: '0 14px 28px rgba(31, 60, 136, 0.06)',
                                                            overflow: 'hidden',
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                background: `linear-gradient(135deg, ${BRAND_NAVY} 0%, ${BRAND_BLUE} 100%)`,
                                                                padding: 22,
                                                            }}
                                                        >
                                                            <div className="d-flex flex-wrap align-items-center justify-content-between">
                                                                <button
                                                                    type="button"
                                                                    onClick={() => toggleOrigin(group.key)}
                                                                    style={{
                                                                        alignItems: 'center',
                                                                        background: 'transparent',
                                                                        border: 'none',
                                                                        color: '#fff',
                                                                        display: 'flex',
                                                                        gap: 16,
                                                                        padding: 0,
                                                                        textAlign: 'left',
                                                                    }}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            alignItems: 'center',
                                                                            background: 'rgba(255,255,255,0.16)',
                                                                            borderRadius: 16,
                                                                            display: 'flex',
                                                                            height: 48,
                                                                            justifyContent: 'center',
                                                                            width: 48,
                                                                        }}
                                                                    >
                                                                        <FaMapMarkerAlt size={18} />
                                                                    </div>

                                                                    <div>
                                                                        <div style={{ fontSize: 22, fontWeight: 700, lineHeight: 1.1 }}>
                                                                            {group.label}
                                                                        </div>
                                                                        <div style={{ marginTop: 5, opacity: 0.84 }}>
                                                                            {group.items.length} {group.items.length > 1 ? 'opções cadastradas' : 'opção cadastrada'}
                                                                        </div>
                                                                    </div>
                                                                </button>

                                                                <div className="d-flex flex-wrap align-items-center mt-3 mt-lg-0">
                                                                    <div
                                                                        style={{
                                                                            background: 'rgba(255,255,255,0.12)',
                                                                            border: '1px solid rgba(255,255,255,0.18)',
                                                                            borderRadius: 999,
                                                                            color: '#fff',
                                                                            fontSize: 12,
                                                                            fontWeight: 700,
                                                                            letterSpacing: '0.08em',
                                                                            marginRight: 10,
                                                                            padding: '8px 12px',
                                                                            textTransform: 'uppercase',
                                                                        }}
                                                                    >
                                                                        {group.items.length} {group.items.length > 1 ? 'opções' : 'opção'}
                                                                    </div>

                                                                    <button
                                                                        type="button"
                                                                        onClick={() => addOptionToOrigin(group.originValue ?? '')}
                                                                        className="btn"
                                                                        style={{
                                                                            background: '#fff',
                                                                            borderRadius: 999,
                                                                            color: BRAND_NAVY,
                                                                            fontWeight: 700,
                                                                            marginRight: 10,
                                                                            padding: '8px 14px',
                                                                        }}
                                                                    >
                                                                        <FaPlus size={14} style={{ marginRight: 8 }} />
                                                                        Adicionar opção
                                                                    </button>

                                                                    <button
                                                                        type="button"
                                                                        onClick={() => toggleOrigin(group.key)}
                                                                        className="btn"
                                                                        style={{
                                                                            background: 'rgba(255,255,255,0.14)',
                                                                            border: '1px solid rgba(255,255,255,0.18)',
                                                                            borderRadius: 999,
                                                                            color: '#fff',
                                                                            padding: '8px 12px',
                                                                        }}
                                                                    >
                                                                        {isExpanded ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {isExpanded ? (
                                                            <div style={{ background: BRAND_SKY, padding: 24 }}>
                                                                <div
                                                                    className="mb-4"
                                                                    style={{
                                                                        background: '#fff',
                                                                        border: `1px solid ${BRAND_BORDER}`,
                                                                        borderRadius: 18,
                                                                        padding: 20,
                                                                    }}
                                                                >
                                                                    <div style={{ color: '#7b8ba7', fontSize: 12, fontWeight: 700, letterSpacing: '0.08em', marginBottom: 8, textTransform: 'uppercase' }}>
                                                                        Configuração da origem
                                                                    </div>
                                                                    <div className="row align-items-end">
                                                                        <div className="col-md-7 col-lg-5">
                                                                            <div className="form-group mb-0">
                                                                                <label
                                                                                    style={{
                                                                                        color: BRAND_NAVY,
                                                                                        display: 'block',
                                                                                        fontSize: 12,
                                                                                        fontWeight: 700,
                                                                                        letterSpacing: '0.04em',
                                                                                        marginBottom: 6,
                                                                                        textTransform: 'uppercase',
                                                                                    }}
                                                                                >
                                                                                    Cidade de origem
                                                                                </label>
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control"
                                                                                    style={{
                                                                                        background: '#fff',
                                                                                        border: `1px solid ${BRAND_BORDER}`,
                                                                                        borderRadius: 12,
                                                                                        minHeight: 46,
                                                                                    }}
                                                                                    value={group.originValue ?? ''}
                                                                                    onChange={(event) => updateOriginForGroup(group, event.target.value)}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {group.items.map(({ rowIndex, option }, optionIndex) => (
                                                                    <div
                                                                        className="mb-4"
                                                                        key={rowIndex}
                                                                        style={{
                                                                            background: '#fff',
                                                                            border: `1px solid ${BRAND_BORDER}`,
                                                                            borderRadius: 20,
                                                                            boxShadow: '0 10px 20px rgba(31, 60, 136, 0.05)',
                                                                            overflow: 'hidden',
                                                                        }}
                                                                    >
                                                                        <div
                                                                            className="d-flex flex-wrap align-items-center justify-content-between"
                                                                            style={{
                                                                                background: 'linear-gradient(180deg, #ffffff 0%, #f7fbff 100%)',
                                                                                borderBottom: `1px solid ${BRAND_BORDER}`,
                                                                                padding: '18px 22px',
                                                                            }}
                                                                        >
                                                                            <div>
                                                                                <div style={{ color: BRAND_NAVY, fontSize: 20, fontWeight: 700 }}>
                                                                                    Opção {optionIndex + 1}
                                                                                </div>
                                                                                <div style={{ color: '#6f809b', marginTop: 4 }}>
                                                                                    Ida e retorno organizados no mesmo conjunto de opção.
                                                                                </div>
                                                                            </div>

                                                                            <SoftActionButton
                                                                                color="warning"
                                                                                icon={<FaTrash size={13} />}
                                                                                label="Remover"
                                                                                onClick={() => removeOption(rowIndex)}
                                                                            />
                                                                        </div>

                                                                        <div style={{ padding: 22 }}>
                                                                            <div className="row">
                                                                                <div className="col-lg-6 mb-3 mb-lg-0">
                                                                                    <div
                                                                                        style={{
                                                                                            background: '#f7fbff',
                                                                                            border: `1px solid ${BRAND_BORDER}`,
                                                                                            borderRadius: 18,
                                                                                            height: '100%',
                                                                                            padding: 18,
                                                                                        }}
                                                                                    >
                                                                                        <div className="d-flex align-items-center mb-3">
                                                                                            <div
                                                                                                style={{
                                                                                                    alignItems: 'center',
                                                                                                    background: '#dcecff',
                                                                                                    borderRadius: 12,
                                                                                                    color: BRAND_BLUE,
                                                                                                    display: 'flex',
                                                                                                    height: 38,
                                                                                                    justifyContent: 'center',
                                                                                                    marginRight: 12,
                                                                                                    width: 38,
                                                                                                }}
                                                                                            >
                                                                                                <FaPlaneDeparture size={16} />
                                                                                            </div>
                                                                                            <div>
                                                                                                <div style={{ color: BRAND_NAVY, fontSize: 18, fontWeight: 700 }}>Trecho de Ida</div>
                                                                                                <div style={{ color: '#6f809b' }}>Campos da saída do participante até o destino.</div>
                                                                                            </div>
                                                                                        </div>
                                                                                        {renderFieldGrid(IDA_FIELDS, option, (field, value) => updateOptionField(rowIndex, field, value))}
                                                                                    </div>
                                                                                </div>

                                                                                <div className="col-lg-6">
                                                                                    <div
                                                                                        style={{
                                                                                            background: '#fff9f3',
                                                                                            border: '1px solid #ffe0bc',
                                                                                            borderRadius: 18,
                                                                                            height: '100%',
                                                                                            padding: 18,
                                                                                        }}
                                                                                    >
                                                                                        <div className="d-flex align-items-center mb-3">
                                                                                            <div
                                                                                                style={{
                                                                                                    alignItems: 'center',
                                                                                                    background: '#ffe8cb',
                                                                                                    borderRadius: 12,
                                                                                                    color: '#d68000',
                                                                                                    display: 'flex',
                                                                                                    height: 38,
                                                                                                    justifyContent: 'center',
                                                                                                    marginRight: 12,
                                                                                                    width: 38,
                                                                                                }}
                                                                                            >
                                                                                                <FaPlaneArrival size={16} />
                                                                                            </div>
                                                                                            <div>
                                                                                                <div style={{ color: BRAND_NAVY, fontSize: 18, fontWeight: 700 }}>Trecho de Retorno</div>
                                                                                                <div style={{ color: '#6f809b' }}>Campos da volta do participante para a origem.</div>
                                                                                            </div>
                                                                                        </div>
                                                                                        {renderFieldGrid(RETORNO_FIELDS, option, (field, value) => updateOptionField(rowIndex, field, value))}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                );
                                            })}

                                            <div className="row fixoRodape">
                                                <div className="col-12 d-flex justify-content-end">
                                                    <button
                                                        type="submit"
                                                        className="btn"
                                                        style={{
                                                            background: `linear-gradient(135deg, ${BRAND_NAVY} 0%, ${BRAND_BLUE} 100%)`,
                                                            borderRadius: 14,
                                                            boxShadow: '0 12px 24px rgba(45, 127, 249, 0.22)',
                                                            color: '#fff',
                                                            fontWeight: 700,
                                                            padding: '12px 22px',
                                                        }}
                                                    >
                                                        <FaSave size={16} style={{ marginRight: 8 }} />
                                                        Salvar alterações
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </ErpTemplate>
    );
}
